module.exports = __webpack_public_path__ + "static/img/adv-white-logo.c792bd68.png";